import { isEmpty } from '@jjj/components';
import { t } from 'src/i18n';
import actions from './actions';
import { createReducer } from '../../helpers/reducer';
import { keyBy } from '../../helpers/core';
import { setLanguage } from '../../i18n';

const initState = {
  settings: {
    apiUrl: '',
    wsUrl: '',
    language: '',
  },
  editForm: null,
  isEdit: false,
};

function validate(attr, value) {
  let error = '';

  if (attr === 'apiUrl') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.editSettings.api_address_label'),
      });
    }
  }

  return error;
}

function omInitDataCompleted(state, { payload }) {
  const { settings } = payload;

  return {
    ...state,
    settings,
  };
}

function onSaveSuccess(state, { payload }) {
  const { settings } = payload;

  setLanguage(settings.language);

  return {
    ...state,
    settings,
    isEdit: false,
  };
}

function onEdit(state) {
  const propsArray = Object.keys(state.settings);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: state.settings[prop],
      error: validate(prop, state.settings[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    isEdit: true,
    editForm,
  };
}

function onClearStore() {
  return { ...initState };
}

function onClearSettingsSuccess(state, { payload }) {
  const { settings } = payload;

  return {
    ...state,
    settings,
  };
}

function onCancel(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

export default createReducer(initState, {
  [actions.INIT_DATA_COMPLETED]: omInitDataCompleted,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.EDIT]: onEdit,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CANCEL]: onCancel,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CLEAR_SETTINGS_SUCCESS]: onClearSettingsSuccess,
});
